<script>
  export let similar = null;
  export let recent = null;
  export let recommended = null;
  export let boughtTogether = null;

  let preview = 'similar';
  let previewProducts = [
    {
      name: 'Syltherine',
      price: '160',
      image: '/img/preview-product-1.png',
    },
    {
      name: 'Lolito',
      price: '240',
      image: '/img/preview-product-2.png',
    },
    {
      name: 'Black chair',
      price: '240',
      image: '/img/preview-product-3.png',
    },
    {
      name: 'Blue armchair',
      price: '360',
      image: '/img/preview-product-4.png',
    },
  ];

  $: defaultText = {
    similar: {
      default: 'Other products you may like',
      changed: similar,
    },
    recent: {
      default: 'Recently viewed products',
      changed: recent,
    },
    recommended: {
      default: 'Recommended for you',
      changed: recommended,
    },
    boughtTogether: {
      default: 'Frequently Bought Together',
      changed: boughtTogether,
    },
  };
</script>

<section class="sb-carousel carousel-preview-wrapper" style="--pageSize:4;">
  <h2>
    {defaultText[preview] && defaultText[preview].changed ? defaultText[preview].changed : defaultText[preview].default}
  </h2>
  <div class="sb-carousel--list">
    <div class="sb-carousel--control sb-carousel--prev sb-carousel--control__disabled">
      <svg width="12" height="14" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"
        ><path
          d="M2 9.99998L9.9924 18M2.0038 10.0038L10 2.00757"
          stroke="#575757"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        /></svg
      >
    </div>
    {#each previewProducts as product}
      <li class="sb-item">
        <div class="sb-img--wrapper">
          <img width="90px" height="90px" src={product.image} alt="Carousel preview product" />
        </div>
        <div class="sb-item--details">
          <p class="sb-product-name">{product.name}</p>
          <div class="sb-prices-wrapper">
            <span class="sb-price-wrapper">
              <span class="sb-price ">€{product.price}</span>
            </span>
          </div>
        </div>
      </li>
    {/each}

    <div class="sb-carousel--control sb-carousel--next">
      <svg width="12" height="14" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"
        ><path
          d="M10 9.99998L2.0076 18M9.9962 10.0038L2 2.00757"
          stroke="#575757"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        /></svg
      >
    </div>
  </div>
  <p class="preview-switch">
    Preview for :
    <span on:click={() => (preview = 'similar')} class:active={preview == 'similar'}>Similar</span>
    <span on:click={() => (preview = 'recent')} class:active={preview == 'recent'}>Recent</span>
    <span on:click={() => (preview = 'recommended')} class:active={preview == 'recommended'}>Recommended</span>
    <span on:click={() => (preview = 'boughtTogether')} class:active={preview == 'boughtTogether'}>Bought Together</span>
  </p>
</section>

<style>
  .carousel-preview-wrapper {
    height: 100%;
    width: 500px;
    position: absolute;
    top: 0;
    left: 100%;
    margin: 0 0 0 1em;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: scale(0.8);
    transform-origin: left;
  }

  .sb-carousel--list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .sb-item {
    flex-basis: 20%;
    list-style: none;
    padding: 0.5em;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
  }
  h2,
  .sb-product-name {
    font-family: 'Montserrat', sans-serif;
    font-weight: 100;
    color: var(--t-c);
  }
  h2 {
    font-size: 1.2rem;
    text-align: center;
    margin-bottom: 1em;
  }
  .sb-product-name,
  .sb-price {
    font-size: 0.75rem;
  }
  .sb-price {
    color: #000;
  }
  .preview-switch {
    align-self: flex-start;
    color: var(--t-c);
    margin-top: 1.5em;
    font-size: 0.8rem;
    transform: scale(1.1);
    transform-origin: left;
  }
  .preview-switch span {
    cursor: pointer;
    color: var(--t-c-l);
    font-size: 1rem;
    margin-right: 0.3em;
  }
  span.active {
    color: var(--t-c);
    text-decoration: underline;
  }
  @media (max-width: 1200px) {
    .carousel-preview-wrapper {
      display: none;
    }
  }
</style>
